export default __webpack_public_path__ + "static/media/Mejuri.bcb723de.jpg";